var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Checkbox',{attrs:{"binary":true},model:{value:(_vm.localSlPhModuleOnly),callback:function ($$v) {_vm.localSlPhModuleOnly=$$v},expression:"localSlPhModuleOnly"}}),_c('span',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }